import "./Eclipse.module.css";
import Header from "@/reusable_sections/Header";
import IntoTheShadow from "./sections/IntoTheShadow";
import TheSonicJourney from "./sections/TheSonicJourney";
import LiveUnfiltered from "./sections/LiveUnfiltered";
import OnTheHorizon from "./sections/OnTheHorizon";
import IndustryAccess from "./sections/IndustryAccess";
import JoinTheEclipse from "./sections/JoinTheEclipse";
import Footer from "@/reusable_sections/Footer";
export default function EclipsePage() {
  return <div>
      <Header />
      <IntoTheShadow />
      <TheSonicJourney />
      <LiveUnfiltered />
      <OnTheHorizon />
      <IndustryAccess />
      <JoinTheEclipse />
      <Footer />
    </div>;
}